import React, { useEffect, useRef, useState } from "react";
import { api, formatApiError } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { setError("Session introuvable."); return; }
    const session_id = decodeURIComponent(m[1]);
    api.post("/auth/google", { session_id })
      .then(({ data }) => {
        localStorage.setItem("fd_token", data.token);
        window.location.href = "/mail";
      })
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || "Échec de la connexion Google."));
  }, []);

  return (
    <div className="h-[100dvh] flex flex-col items-center justify-center bg-background gap-3">
      {error ? (
        <>
          <p className="text-signal font-medium">{error}</p>
          <a href="/login" className="text-sm text-klein underline">Retour à la connexion</a>
        </>
      ) : (
        <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-zinc-400 animate-pulse">Connexion Google…</p>
      )}
    </div>
  );
}
